import React, { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import "./StockBoards.css"

const IG_TOKEN =
  "IGAAV9ffwbfZA9BZAFlHYTN4TkpjMnh6a01XMWR0SG4xeDRMd2cyY0UyR0w1dnNEY1U0c0YtdHJrR2FVeWNDU2NrYXozcDZAnQ2c2NlhoOUY2NU5jNDdqYWNhdndfWk43QThSOGVnME9IOTFrZA2NXZAjJ0Nk9qWkhiYW43ZATlTRTV2NAZDZD"

function parseDimensions(caption) {
  if (!caption) return null
  const c = caption
    .replace(/[\u2018\u2019\u2032]/g, "'")
    .replace(/[\u201C\u201D\u2033]/g, '"')
  const m = c.match(
    /(\d+)'(\d+(?:\.\d+)?)"?\s*[xX×]\s*([\d.]+)"?\s*[xX×]\s*([\d.]+(?:\s+\d+\/\d+)?)"?/
  )
  if (m) return `${m[1]}'${m[2]}" × ${m[3]}" × ${m[4]}"`
  return null
}

const StockBoards = () => {
  const [boards, setBoards] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const allPosts = []
    const fetchPage = (url) => {
      fetch(url)
        .then((r) => r.json())
        .then((data) => {
          if (data.data) allPosts.push(...data.data)
          // Follow pagination until we have ~200 posts or no more pages
          if (data.paging?.next && allPosts.length < 200) {
            fetchPage(data.paging.next)
          } else {
            const filtered = allPosts.filter(
              (p) =>
                (p.media_type === "IMAGE" || p.media_type === "CAROUSEL_ALBUM") &&
                p.caption?.toLowerCase().includes("up for grabs")
            )
            setBoards(filtered)
            setLoading(false)
          }
        })
        .catch(() => setLoading(false))
    }
    fetchPage(
      `https://graph.instagram.com/me/media?fields=id,caption,media_type,media_url,permalink&limit=100&access_token=${IG_TOKEN}`
    )
  }, [])

  return (
    <div className="sb-page">
      <Link to="/" className="sb-back">
        &larr; Back
      </Link>
      <header className="sb-header">
        <span className="sb-eyebrow">Ready to Ride</span>
        <h1 className="sb-title">Stock Boards</h1>
        <p className="sb-subtitle">
          Can't wait to get in the water? Grab a board off the rack.
        </p>
      </header>

      {loading ? (
        <p className="sb-loading">Loading...</p>
      ) : boards.length === 0 ? (
        <p className="sb-empty">
          No stock boards available right now — check back soon.
        </p>
      ) : (
        <div className="sb-grid">
          {boards.map((post, i) => {
            const dims = parseDimensions(post.caption)
            const isSold = i >= 2 || post.caption?.toLowerCase().includes("(sold)")
            return (
              <div
                key={post.id}
                className={`sb-card${isSold ? " sb-card--sold" : ""}`}
              >
                <a
                  href={post.permalink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="sb-img-link"
                >
                  <div className="sb-img-wrap">
                    <img
                      src={post.media_url}
                      alt={
                        post.caption ? post.caption.slice(0, 60) : "Stock board"
                      }
                      className="sb-img"
                      loading="lazy"
                    />
                  </div>
                </a>
                {dims && <p className="sb-dims">{dims}</p>}
                {isSold && <p className="sb-sold">SOLD</p>}
                {!isSold && (
                  <Link to="/#contact" className="sb-contact-btn">
                    Contact
                  </Link>
                )}
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}

export default StockBoards
